import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    video: {
      global: '',
      pc:
        'http://huya-w7.huya.com/1914/140725565/yuanhua/d0b3e9404cf8f4643f434e2ad6600930.mp4',
      cloud:
        'http://huya-w7.huya.com/1914/140739889/yuanhua/b8c0f432f42fb0b623fb0a340235da5f.mp4',
      welcome:
        'http://huya-w7.huya.com/1914/140736897/yuanhua/a072b89733300109c91e2876769eac09.mp4',
      giftTks:
        'http://huya-w7.huya.com/1914/140738267/yuanhua/8ee54a8f52bdfc5eb217b01982446027.mp4',
      keyPerson: '',
      blacklist:
        'http://huya-w7.huya.com/1914/140742803/yuanhua/d935284f6a22c3fa3a4f5ea7a5967b9e.mp4',
      guide:
        'http://huya-w7.huya.com/1914/140741029/yuanhua/bbdd1554f7e100d62422c0924193bf6d.mp4',
      autoReply:
        'http://huya-w6.huya.com/1914/140742169/yuanhua/82e9064530bd9b4b0633bf9396c46501.mp4',
      AIChat: '',
      readText: '',
      signData: '',
      giftData: '',
      robot: '',
      guessNum: ''
    },
    isWeixin: navigator.userAgent.match(/MicroMessenger/i),
    isPC: !navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    ),
    isElectron: !!window.electron,
    user: {},
    robotList: [],
    agentType: -1,
    cloud: {
      user: null
    },
    showLoading: false,
    guideType: 'normal',
    canFree:false, // 是否已经领过free
  },
  mutations: {
    UPDATE_ROBOTLIST(state, robotlist) {
      state.robotList = robotlist
    },
    UPDATE_USER(state, user) {
      state.user = user
    },
    UPDATE_AGENTTYPE(state, agenttype) {
      state.agentType = agenttype
    },
    UPDATE_CLOUDUSER(state, user) {
      if (user.user) {
        state.cloud.user = user.user
      } else {
        if (user.user == null) {
          state.cloud.user = null
        } else {
          state.cloud.user = user
        }
      }
    },
    CHANGE_LOADINGSTATUS(state, status) {
      state.showLoading = status
    },
    CHANGEGUIDETYPE(state, guideType) {
      state.guideType = guideType
    },
    UPDATE_FREE_DATA(state,status) { 
      state.canFree = status
    }
  },
  actions: {
    updateRobotList({ commit }, robotlist) {
      commit('UPDATE_ROBOTLIST', robotlist)
    },
    updateUser({ commit }, user) {
      // if (FS) {
      //     FS.identify(user.account, {
      //         displayName: user.name
      //     })
      // }
      commit('UPDATE_USER', user)
    },
    updateAgentType({ commit }, agenttype) {
      commit('UPDATE_AGENTTYPE', agenttype)
    },
    updateClouduser({ commit }, data) {
      commit('UPDATE_CLOUDUSER', data)
    },
    changeLoadingStatus({ commit }, status) {
      commit('CHANGE_LOADINGSTATUS', status)
    },
    changeGuideType({ commit }, guideType) {
      commit('CHANGEGUIDETYPE', guideType)
    }
  }
})
